(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PageHero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  var videoModal = document.getElementById("videoModal");
  var videoIframe = videoModal.querySelector("iframe");
  var videoSrc = "";

  // When clicking play button
  document.querySelectorAll(".btn-play-medium").forEach(function (btn) {
    btn.addEventListener("click", function () {
      videoSrc = this.getAttribute("data-src");
      console.log('Video SRC',videoSrc);
    });
  });

  // Set src only when modal is fully shown
  videoModal.addEventListener("shown.bs.modal", function () {
    videoIframe.setAttribute("src", videoSrc + "?autoplay=1");
  });

  // Remove src when modal is closed
  videoModal.addEventListener("hide.bs.modal", function () {
    videoIframe.setAttribute("src", "");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-hero"]) return;
  try {
    
  console.log("test")
  

  } catch(e) { console.error(e); }
})();
})();
